"use client"

import SwissHeroSection from "../../components/SwissHeroSection"
import BenefitsSection from "../../components/BenefitsSection"
import Testimonials from "../../components/Testimonials"
import FaqSection from "../../components/FaqSection"
import Footer from "../../components/Footer"
import TopMenu from "../../components/TopMenu"
import Hero from "../../components/Hero"

const SwissPageClient = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col overflow-x-hidden">
      <TopMenu />
      <SwissHeroSection />
      <Hero />
      <Testimonials isSwiss />
      <FaqSection isSwiss />
      <Footer />
    </div>
  )
}

export default SwissPageClient
